import { request } from '@/api/httpClient'
import { FittingType } from '@/enums'
import { useSandboxStore } from '@/pinia/sandbox'

export async function processingBasketSummary(CustomerId, ContractId, JobKey, ProcessingLevel) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/BasketSummary'),
    payload: {
      CustomerId,
      ContractId,
      JobKey,
      ProcessingLevel
    }
  })
}

export async function processingAddStockItem(ContractId, JobKey, ItemId, Quantity, LinkToItemKey) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/AddStockItem'),
    payload: {
      ContractId,
      JobKey,
      ItemId,
      LinkToItemKey,
      Quantity
    }
  })
}

export async function processingContract(contractId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/Contract'),
    payload: {
      ContractId: contractId
    }
  })
}

export async function processingSetVisualisations(contractId, jobKey, visualisations) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/SetVisualisations'),
    payload: {
      ContractId: contractId,
      JobKey: jobKey,
      Visualisations: visualisations
    }
  })
}

export async function processingGetAvailableProductsToSelect(typeId, groupId, customerId, Sandbox) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetAvailableProductsToSelect'),
    payload: {
      TypeId: typeId,
      GroupId: groupId,
      CustomerId: customerId,
      Sandbox
    }
  })
}

export async function processingGetProductsForPricing({ typeId, groupId, customerId, sandbox }) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetProductsForPricing'),
    payload: {
      TypeId: typeId,
      GroupId: groupId,
      CustomerId: customerId,
      Sandbox: sandbox
    }
  })
}

export async function processingGetAvailableProductSelectionGroups(customerId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetAvailableProductSelectionGroups'),
    payload: {
      CustomerId: customerId
    }
  })
}

export async function processingGetAvailableProductSelectionTypes(customerId, groupId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetAvailableProductSelectionTypes'),
    payload: {
      GroupId: groupId,
      CustomerId: customerId
    }
  })
}

export async function getProducts() {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/Products')
  })
}

export async function processingGetCustomerPriceBreakdown(contractId, jobId, itemId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetCustomerPriceBreakdown'),
    payload: {
      ContractId: contractId,
      JobKey: jobId,
      ItemKey: itemId
    }
  })
}

export async function processingProductStoredDesigns(
  customerId,
  processingLevel,
  productId,
  width = undefined,
  height = undefined,
  bayBowOnly = false,
  limit = 1000000,
  offset = 0,
  squaresQty = undefined,
  coupledOnly = false
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ProductStoredDesigns'),
    payload: {
      ProductId: productId,
      OnlyShowBayBowCompatible: bayBowOnly,
      OnlyShowCoupledCompatible: coupledOnly,
      TargetWidth: width ? Number(width) : undefined,
      TargetHeight: height ? Number(height) : undefined,
      ProcessingLevel: processingLevel,
      Limit: limit,
      Offset: offset,
      QtySquares: squaresQty,
      CustomerId: customerId
    }
  })
}

export async function processingGetProcessingLevel() {
  const sandboxStore = useSandboxStore()
  const { processingLevelId } = await request({
    method: await sandboxStore.processingUrl('processing/GetProcessingLevel')
  })
  return processingLevelId
}

export async function processingCreateJobLineItem(
  customerId,
  contractId,
  jobKey,
  designId,
  productId,
  processingLevel
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/CreateJobLineItem'),
    payload: {
      ContractId: contractId,
      CustomerId: customerId,
      JobKey: jobKey,
      ProductStoredDesignId: designId,
      ProductId: productId,
      ProcessingLevel: processingLevel
    }
  })
}

export async function processingCreateJobLineItemFromDesigner({
  ContractId,
  CustomerId,
  JobKey,
  ProcessingLevel,
  Designer
}) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/CreateJobLineItemFromDesigner'),
    payload: { ContractId, CustomerId, JobKey, Designer, ProcessingLevel }
  })
}

export async function processingGetChildProductsForProductId(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetChildProductsForProductId'),
    payload
  })
}

export async function processingUpdateJobLineItemDimension(
  customerId,
  contractId,
  jobKey,
  itemKey,
  processingLevel,
  dimensionId,
  value
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineItemDimension'),
    payload: {
      CustomerId: customerId,
      ContractId: contractId,
      JobKey: jobKey,
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processingLevel,
      DimensionId: dimensionId,
      Value: parseInt(value, 10)
    }
  })
}

export async function processingUpdateJobLineItemQuantity(
  customerId,
  contractId,
  jobKey,
  itemKey,
  processingLevel,
  qty
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineItemQuantity'),
    payload: {
      CustomerId: customerId,
      ContractId: contractId,
      JobKey: jobKey,
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processingLevel,
      NewQuantity: parseInt(qty, 10)
    }
  })
}

export async function processingUpdateJobLineStockItemQuantity(contractId, jobKey, itemKey, processingLevel, qty) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineStockItemQuantity'),
    payload: {
      ContractId: contractId,
      JobKey: jobKey,
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processingLevel,
      NewQuantity: parseInt(qty, 10)
    }
  })
}

export async function processingUpdateJobLineItemOption(
  customerId,
  contractId,
  jobKey,
  itemKey,
  processingLevel,
  heading,
  value,
  components,
  members,
  parameters,
  text,
  rule
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineItemOption'),
    payload: {
      CustomerId: customerId,
      ContractId: contractId,
      JobKey: jobKey,
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processingLevel,
      OptionHeadingId: heading,
      NewOptionId: value,
      OnlyTheseComponents: components,
      OnlyTheseMembers: members,
      Text: text,
      Parameters: parameters,
      Rule: parseInt(rule, 10)
    }
  })
}

export async function processingCreateTradeQuote(customerId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/createTradeQuote'),
    payload: {
      CustomerId: customerId
    }
  })
}

export async function processingGetEarliestDeliveryDate(contractId, jobKey) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetEarliestDeliveryDate'),
    payload: {
      ContractId: contractId,
      JobKey: jobKey
    }
  })
}

export async function processingForceDefaults(contractId, jobKey, itemKey, processingLevel) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ForceDefaults'),
    payload: {
      ContractId: contractId,
      JobKey: jobKey,
      ItemKey: itemKey,
      ProcessingLevel: processingLevel
    }
  })
}

export async function processingCreateTradeOrder(customerId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/createTradeOrder'),
    payload: {
      CustomerId: customerId
    }
  })
}

export async function processingJobLineItem(
  customerId,
  contractId,
  jobKey,
  itemKey,
  processingLevel,
  recalculate = false,
  visualiserImages = false
) {
  const sandboxStore = useSandboxStore()
  const item = await request({
    method: await sandboxStore.processingUrl('processing/JobLineItem'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      JobKey: jobKey,
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processingLevel,
      Recalculate: recalculate,
      FormatImagesForVisualiser: visualiserImages
    }
  })

  return item
}

export async function processingJob(contractId, jobKey, recalculate = false) {
  const sandboxStore = useSandboxStore()
  const rawJob = await request({
    method: await sandboxStore.processingUrl('processing/Job'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobKey, 10),
      Recalculate: recalculate
    }
  })

  if (!rawJob?.exchangeRate) {
    rawJob.exchangeRate = 1
  }

  return rawJob
}

export async function processingUpdateJobLineItemNestedDesign(
  customerId,
  contractId,
  jobKey,
  itemKey,
  processsingLevel,
  productId,
  designId,
  containerId
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineItemNestedDesign'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobKey, 10),
      ItemKey: parseInt(itemKey, 10),
      ProcessingLevel: processsingLevel,
      ProductId: parseInt(productId, 10),
      StoredDesignId: designId,
      ContainerId: containerId
    }
  })
}

export async function processingGetChildProducts(contractId, jobKey, itemKey, width, height, customerId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetChildProducts'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobKey, 10),
      ItemKey: parseInt(itemKey, 10),
      TargetWidth: parseInt(width, 10),
      TargetHeight: parseInt(height, 10)
    }
  })
}

export async function processingSaveContract(
  customerId,
  contractId,
  skipAcceptance = false,
  placeTradeOrder = false,
  useLazySaving = true
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/SaveContract'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      useLazySaving,
      PlaceTradeOrder: placeTradeOrder,
      SkipAcceptance: skipAcceptance
    }
  })
}

export async function processingRemoveContract(contractId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/RemoveContract'),
    payload: {
      ContractId: parseInt(contractId, 10)
    }
  })
}

export async function processingGet3DModel({ contractId, itemKey, jobKey, customerId }) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/Get3dModel'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobKey, 10),
      ItemKey: parseInt(itemKey, 10),
      CustomerId: parseInt(customerId, 10)
    }
  })
}

export async function processingUpdateContract(contractId, payload) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/UpdateContract'),
    payload: {
      ContractId: parseInt(contractId, 10),
      ...payload
    }
  })
}

export async function processingUpdateNote(params) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/UpdateNote'),
    payload: params
  })
}

export async function processingUpdateFittingType(contractId, jobId, isFit) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/UpdateFittingType'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      FittingType: isFit ? FittingType.SUPPLY_AND_FIT : FittingType.SUPPLY_ONLY
    }
  })
}

export async function processingUpdateJob(contractId, jobId, payload) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/UpdateJob'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ...payload
    }
  })
}

export async function processingUpdateJobDelivery(customerId, contractId, jobId, payload) {
  const params = {
    ContractId: parseInt(contractId, 10),
    JobKey: parseInt(jobId, 10),
    ...payload
  }

  if (window.VITE_APP_INSTALLATION_TYPE === 'business') {
    params.CustomerId = parseInt(customerId, 10)
  }

  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobDelivery'),
    payload: params
  })
}

export async function processingUpdateCustomerPONumber(contractId, poNumber) {
  const params = {
    ContractId: parseInt(contractId, 10),
    CustomerPONumber: poNumber
  }
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/UpdateCustomerPONumber'),
    payload: params
  })
}

export async function processingUpdateExistingExtraItem(contractId, jobId, itemId, params) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateExistingExtraItem'),
    payload: {
      ...params,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ItemKey: itemId
    }
  })
}

export async function processingUpdateNewExtraItem(contractId, jobId, itemId, params) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateNewExtraItem'),
    payload: {
      ...params,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ItemKey: itemId
    }
  })
}

export async function processingAddExistingExtraItem(contractId, jobId, extraItemId, itemId = undefined, params = {}) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/AddExistingExtraItem'),
    payload: {
      ...params,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ItemId: extraItemId,
      LinkToItemKey: itemId
    }
  })
}

export async function processingJobDelivery(customerId, contractId, jobId, monthsAhead = 3) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/JobDelivery'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      MonthsAhead: parseInt(monthsAhead, 10)
    }
  })
}

export async function processingUpdateJobLineItemRequote(contractId, jobId, processingLevel, items) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobLineItemRequote'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ProcessingLevel: processingLevel,
      Items: items.map((item) => ({
        Override: true,
        ItemKey: parseInt(item.itemKey, 10),
        Value: parseFloat(item.price),
        TaxExempt: false
      }))
    }
  })
}

export async function processingReloadContract(customerId, contractId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ReloadContract'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10)
    }
  })
}

export async function processingDeleteJob(contractId, jobId) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/DeleteJob'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10)
    }
  })
}

export async function processingDeleteLineItem(contractId, jobId, lineItemId) {
  const sandboxStore = useSandboxStore()
  await request({
    method: await sandboxStore.processingUrl('processing/DeleteJobLineItem'),
    payload: {
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ItemKey: parseInt(lineItemId, 10)
    }
  })
}

export async function processingDuplicateItem(customerId, contractId, jobId, lineItemId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/DuplicateItem'),
    payload: {
      CustomerId: customerId,
      ContractId: parseInt(contractId, 10),
      JobKey: parseInt(jobId, 10),
      ItemKey: parseInt(lineItemId, 10)
    }
  })
}

export async function processingGetEnquiryStatuses() {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetEnquiryStatuses')
  })
}

export async function processingUpdateQuoteStatus(contractId, status) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateQuoteStatus'),
    payload: {
      ContractId: Number(contractId),
      Status: Number(status)
    }
  })
}

export async function processingUpdateEnquiryStatus(contractId, status) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateEnquiryStatus'),
    payload: {
      ContractId: Number(contractId),
      Status: Number(status)
    }
  })
}

export async function processingUpdateDealerEnquiryStatus(dealerNetworkAssignmentId, status, refusalReason = '') {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('contract/UpdateDealerEnquiryStatus'),
    payload: {
      dealerNetworkAssignmentId: Number(dealerNetworkAssignmentId),
      DealerStatus: Number(status),
      RefusalReason: refusalReason
    }
  })
}

export async function processingGetDocsToAccept() {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetDocsToAccept')
  })
}

export async function processingProductSelectionStage(selectedStages) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ProductSelectionStage'),
    payload: { SelectedStages: selectedStages }
  })
}

export async function processingConvertDealerEnquiry(contractId, jobIds, processingLevel) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ConvertDealerEnquiry'),
    payload: {
      ContractId: Number(contractId),
      JobKeys: jobIds.map((jobId) => Number(jobId)),
      ProcessingLevelId: processingLevel
    }
  })
}

export async function processingImage(contractId, jobKey, itemKey, imageType) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/Image'),
    payload: {
      contractId,
      jobKey,
      itemKey,
      imageType
    }
  })
}

export async function processingAddStaffToContract(ContractId, JobKey, Role, StaffId) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/AddStaffToContract'),
    payload: {
      ContractId,
      JobKey,
      Role,
      StaffId
    }
  })
}

export async function processingGetItemPriceBreakdown(CustomerId, ContractId, JobKey, ItemKey, ProcessingLevel) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/GetItemPriceBreakdown'),
    payload: {
      CustomerId,
      ContractId,
      JobKey,
      ItemKey,
      ProcessingLevel
    }
  })
}

export async function processingUpdateJobPriceOverride(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateJobPriceOverride'),
    payload
  })
}

export async function processingUpdateFabricatorJobPriceOverride(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateFabricatorJobPriceOverride'),
    payload: payload
  })
}

export async function processingUpdateFabricatorItemPriceOverride(
  CustomerId,
  ContractId,
  JobKey,
  ItemKey,
  OverrideItemCalculatedPrice,
  OverrideItemPriceExTax
) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateFabricatorItemPriceOverride'),
    payload: {
      CustomerId,
      ContractId,
      JobKey,
      ItemKey,
      OverrideItemCalculatedPrice,
      OverrideItemPriceExTax
    }
  })
}

export async function processingApplyDiscountVoucher(discount) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ApplyDiscountVoucher'),
    payload: discount
  })
}

export async function processingAvailableBranchesForContract(query) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/AvailableBranchesForContract'),
    payload: query
  })
}

export async function processingUpdateBranch(query) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateBranch'),
    payload: query
  })
}

export async function processingUpdateIssuePresentConfirmed({ ContractId, IssuePresentAccepted }) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateIssuePresentConfirmed'),
    payload: { ContractId, IssuePresentAccepted }
  })
}

export async function processingAddFreeTypeExtraItem(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/AddFreeTypeExtraItem'),
    payload
  })
}

export async function processingUpdateFreeTypeExtraItem(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/UpdateFreeTypeExtraItem'),
    payload
  })
}

export async function processingExtendContractExpiry(payload) {
  const sandboxStore = useSandboxStore()
  return request({
    method: await sandboxStore.processingUrl('processing/ExtendContractExpiry'),
    payload
  })
}
